module.exports = __webpack_public_path__ + "static/media/MItheater2.664ce80d.jpg";